import React, {Component} from 'react';
import {connector, store} from '../store';

import ga from '../../../vendor/google-analytics';

class RelatedShows extends Component {

  renderRelated() {

    let relatedShows = this.props.show.related_shows;

    if (relatedShows.length > 0) {

      let srcsetWidths = [
        160,
        260,
        320
      ];

      let srcSet = function(show) {
        let poster = show.related_show_poster.replace(/http:/, '');

        // Only generate a srcset if this is a PBS hosted poster
        if (poster.search(/pbs\.org/) === -1) {
          return '';
        }

        return srcsetWidths.map(width => {
          return `${poster}.resize.${width}x${width * 1.5}.jpg ${width}w`
        }).join(', ');
      };

      let sizes = '(min-width: 1201px) 200px, (min-width: 769px) 16vw, (min-width: 641px) 33vw, 50vw';

      return relatedShows.map((show, index) => {
        let handler = () => {
          let label = [this.props.show.title, show.related_show_title, index].join(' | ');
          ga('send', 'event', 'Show | Related Shows', 'Click Show | [A]', label);
        };

        return <li className='related-item' key={index}>
          <a className="no-delay related-item-watchable" href={show.related_show_link} onClick={handler}>
            <div className="related-item-preview">
              <img className="related-poster" src={show.related_show_poster.replace(/http:/, '')} srcSet={srcSet(show)}
                   sizes={sizes} alt={show.related_show_title}/>
            </div>
          </a>
        </li>
      });
    }
    else return [];
  }

  render() {
    if (this.props.show.fetchedShow) {
      const related = this.renderRelated();
      let allHandler = () => {
        ga('send', 'event', 'Show | Related Shows', 'Click All | [P]', this.props.show.title);
      };

      return (
        <div className="related-shows row">
          <div className="related-show-header section-header small-12 columns">
            <div className="headline">Other Shows You May Like</div>
            <a className="no-delay show-for-xxlarge-up outline-btn" href="/shows-a-z/" onClick={allHandler}>See All Shows</a>
          </div>
          <div className="show-related-shows video-content-row small-12 columns">
            <ul className="small-block-grid-2 large-block-grid-3 xlarge-block-grid-6">
              {related}
            </ul>
          </div>
          <div className="all-shows-bottom hide-for-xxlarge-up small-12 columns">
            <a className="no-delay outline-btn" href="/shows-a-z/" onClick={allHandler}>See All Shows</a>
          </div>
        </div>
      );
    }
    else {
      return (
        <div>fetching.</div>
      );
    }
  }
}

export default connector(RelatedShows);